import React, { FC } from "react";

import { Form, Row, Stack } from "react-bootstrap";

import { useListAllNotesQuery } from "@api/graphql";
import { DetailListTable } from "@components/DetailListTable";
import { Loading } from "@components/loading";
import { useAuthenticationContext } from "@context/authentication";
import { Role } from "@roles";

import { EnableForUser } from "../permission_control/EnableForUser";
import { ProtectedComponent } from "../permission_control/ProtectedComponent";

interface ResaleNotesTableProps {
  resaleId: number;
}

export const ResaleNotesTable: FC<ResaleNotesTableProps> = ({ resaleId }) => {
  const { data, loading, error } = useListAllNotesQuery({
    variables: { resaleId },
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <div>Error loading notes: {error.message}</div>;
  }

  const notes = data?.listAllNotes || [];

  return (
    <DetailListTable
      data={notes}
      headers={[
        {
          label: "Note",
          render: (note) => note.note || "-",
        },
        {
          label: "Created By",
          render: (note) => `By ${note.user_name || "Unknown"}`,
        },
        {
          label: "Date",
          render: (note) => (note.creation_date ? new Date(note.creation_date).toLocaleDateString() : "-"),
        },
      ]}
      rowKey={(note) => note.id}
      emptyMessage="No notes available for this resale."
    />
  );
};

interface NoteProps {
  setNote: (note: string) => void;
  handleConfirmClick: () => void;
  loading: boolean;
  resaleId?: number;
}

export const DetailsNote: FC<NoteProps> = ({ setNote, handleConfirmClick, loading, resaleId }) => {
  const { auth } = useAuthenticationContext();

  return (
    <Stack gap={4} className="col-md-10">
      <Row>
        <span className="h5">Note</span>
      </Row>
      <Row>
        <Form.Group>
          {/*Permit: only VA admin able to Add notes*/}
          <ProtectedComponent requiredGroups={[Role.VisualArtistAdmin]} auth={auth}>
            <EnableForUser requiredGroups={[Role.VisualArtistAdmin]} disableOnUnauth>
              <Form.Control as="textarea" placeholder="" rows={4} onChange={(e) => setNote(e.target.value)} />
            </EnableForUser>

            <button className="btn btn-primary mb-2 me-2 mt-4" onClick={handleConfirmClick} disabled={loading}>
              {loading ? "Saving..." : "Confirm"}
            </button>
          </ProtectedComponent>
        </Form.Group>
      </Row>
      {resaleId && (
        <Row>
          <ResaleNotesTable resaleId={resaleId} />
        </Row>
      )}
    </Stack>
  );
};
